/**
 * Generates a unique React key based on current time
 * @param {string?} prefix
 */
const generateReactKey = (prefix) => {
    const randomNumber = Math.random() * (1 - 0) + 0;
    // Ensure valid string
    const pre = prefix || '';
    return `${pre}_${new Date().getTime()}_${randomNumber}`;
};

export default generateReactKey;

